'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
export { AD_SLOT_DEBUG_PLACEHOLDER_ENABLED } from '@/constants/ad';
interface AdSlotDebugPlaceholderProps {
  //* width/height 생략 시 부모 frame이 크기를 소유한다 (className="size-full"로 채움)
  width?: number;
  height?: number;
  className?: string;
}
export const AdSlotDebugPlaceholder = t0 => {
  const $ = _c(10);
  const {
    width,
    height,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("pointer-events-none flex-col gap-4 border border-dashed border-Gray-300 bg-Gray-100 text-Gray-500 flex-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== height || $[3] !== width) {
    t2 = width !== undefined && height !== undefined ? {
      width: `min(100%, ${width}px)`,
      aspectRatio: `${width} / ${height}`
    } : undefined;
    $[2] = height;
    $[3] = width;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="font-700 typo-caption1">AD</span>;
    t4 = <span className="font-500 typo-caption2">개발용 광고 영역</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2) {
    t5 = <div aria-hidden={true} data-ad-debug-placeholder={true} className={t1} style={t2}>{t3}{t4}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};